import { useMutation, useQueryClient } from "@tanstack/react-query";
import { post } from "@truefit/http-utils";

interface ApiError {
    message: string;
    status: number;
}

export interface CreatedApiKey {
    /** The only time the full key is ever returned. */
    key: string;
    id: number;
    description: string | null;
    success: boolean;
}

export const useCreateApiKeyMutation = (orgId?: number) => {
    const queryClient = useQueryClient();

    return useMutation<CreatedApiKey, ApiError, string | undefined>({
        mutationFn: async (description) => {
            const {data} =  await post<CreatedApiKey>(`/v1.0/user/apikey`, { orgId, description });
            return data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["apikey", orgId] });
        },
        onError: (error) => {
            console.error("Failed to create API key:", error);
        }
    });
};

export default useCreateApiKeyMutation;
